import React, { useState, memo } from 'react';
import { Search, Wind, Wrench, HardHat, X } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Search, Wind, Wrench, HardHat };

const Services = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section id="servizi" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">
          Risolviamo i Tuoi Problemi di Umidità e Allagamenti
        </h2>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.id} className="service-card bg-white rounded-lg overflow-hidden shadow-md border border-gray-100">
                <div className="relative h-56 overflow-hidden">
                  <img src={s.image} alt={`${s.title} - servizio Magic Deumidificazioni Ticino`} loading="lazy" decoding="async" width="600" height="400" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw" className="w-full h-full object-cover" />
                  <button onClick={() => setSelected(s)} className="absolute top-3 right-3 bg-brand-red hover:bg-brand-red-dark text-white text-xs font-bold uppercase tracking-wide px-3 py-1.5 rounded-md transition-colors shadow-md">
                    Scopri di più
                  </button>
                  <div className="absolute left-4 -bottom-6 w-14 h-14 rounded-full bg-white shadow-lg flex items-center justify-center border-2 border-brand-red">
                    <Icon className="w-6 h-6 text-brand-red" />
                  </div>
                </div>
                <div className="p-5 pt-8">
                  <h3 className="font-display text-lg font-bold text-brand-navy uppercase tracking-wide">{s.title}</h3>
                  <p className="text-sm text-gray-600 mt-2 leading-relaxed">{s.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selected && (
        <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 fade-up" onClick={() => setSelected(null)}>
          <div className="bg-white rounded-xl max-w-2xl w-full overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="relative h-64">
              <img src={selected.image} alt={selected.title} loading="lazy" decoding="async" width="1200" height="600" className="w-full h-full object-cover" />
              <button onClick={() => setSelected(null)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-white/90 hover:bg-white flex items-center justify-center transition-colors">
                <X className="w-5 h-5 text-brand-navy" />
              </button>
            </div>
            <div className="p-6">
              <h3 className="font-display text-2xl font-bold text-brand-navy uppercase">{selected.title}</h3>
              <p className="mt-4 text-gray-700 leading-relaxed">{selected.longDescription}</p>
              <a href="#contatti" onClick={() => setSelected(null)} className="mt-6 inline-flex items-center bg-brand-red hover:bg-brand-red-dark text-white px-6 py-3 rounded-md font-semibold text-sm uppercase tracking-wide transition-colors">
                Richiedi informazioni
              </a>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default memo(Services);
